import { createContext } from 'react'

import { UserTrackingClient } from './types'

export const UserTrackingContext = createContext<UserTrackingClient | null>(null)
